export const getReportsExportColumns = (visibleFields: string[]) => {
  if (
    visibleFields.includes('firstName') &&
    !visibleFields.includes('lastName')
  ) {
    return [...visibleFields, 'lastName'];
  }

  if (visibleFields.includes('name') && !visibleFields.includes('email')) {
    return [...visibleFields, 'email'];
  }

  return visibleFields;
};

export const getPhishingReportsExportColumns = (visibleFields: string[]) =>
  visibleFields.filter(
    (field) =>
      !['lastName', 'spacer', 'meta.reported', 'falsePositive'].includes(field),
  );
